export function getTimer(time) {
    let data = new Date(time);
    // let Y = data.getFullYear()
    let M = data.getMonth() + 1;
    let D = data.getDate();
    let h = data.getHours() < 10 ? "0" + data.getHours() : data.getHours();
    let m = data.getMinutes() < 10 ? "0" + data.getMinutes() : data.getMinutes();
    // let s = data.getSeconds() < 10 ? "0" + data.getSeconds() : data.getSeconds()
    // return `${Y}年${M}月${D}日 ${h}:${m}:${s}`;
    return `${M}月${D}日 ${h}:${m}`;
}

export function getFamtterTimer(time) {
    var date = new Date(time),
        MyYear = date.getFullYear(), //年  
        MyMonth = date.getMonth() + 1, //月  
        MyDay = date.getDate(), //日
        h = date.getHours(), //小时
        m = date.getMinutes(), //分钟
        s = date.getSeconds(); //秒数
    var MyTime = MyYear + '-' + getZero(MyMonth) + '-' + getZero(MyDay) + ' ' + getZero(h) + ':' + getZero(m) + ':' + getZero(s); //最后拼接时间  
    return MyTime;
}

export function getZero(num) {
    // 单数前面加0
    if (parseInt(num) < 10) {
        num = '0' + num;
    }
    return num;
}